<form [formGroup]="consumableItemRNDForm">
  <div class="main-box">
    <div class="d-flex p-2 float-end sticky-button">
      <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3">
        <i class="fa-solid fa-download"></i>
        <span class="hidebuttonName"> EXPORT</span>
      </button>
    </div>
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
        <div class="claim-table">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="equal-width-col">{{labelConstants.Details}}</th>
                    <th class="equal-width-col">{{labelConstants.Cost}}</th>
                    <th class="equal-width-col" *ngFor="let item of projectList">
                      {{ item.projectName }}
                    </th>
                    <th class="equal-width-col">  {{labelConstants.Total}}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container formArrayName="consumableItem">
                    <tr *ngFor="
                        let item of consumableItem.controls;
                        let i = index
                      " [formGroupName]="i">
                      <td class="equal-width-col">
                        <span>{{ item.get("consumableItemName")?.value }}</span>
                      </td>
                      <td class="equal-width-col">
                        <span>{{ item.get("totalGross")?.value | customCurrency: env.CurrencyFormat}}</span>
                      </td>
                      <ng-container formArrayName="projects">
                        <td class="equal-width-col" *ngFor="
                            let itemDetails of getProjectDetails(i).controls;
                            let j = index
                          " [formGroupName]="j">
                          <span>{{ itemDetails.get("rndEligibility")?.value | customPercentage:
                            env.CurrencyFormat}}</span>
                        </td>
                      </ng-container>
                      <td>
                        <span>{{
                          item.get("totalEligibilityPer")?.value | customCurrency: env.CurrencyFormat
                          }}</span>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot *ngIf="consumableItem.controls && consumableItem.controls.length > 0; else noRecords">
                  <tr>
                    <td class="equal-width-col" colspan="1"><b>{{labelConstants.ConsumableItem}} (£)</b></td>
                    <td class="equal-width-col">
                      <span><b>{{ getCostTotal() | customCurrency: env.CurrencyFormat}}</b></span>
                    </td>
                    <td class="equal-width-col" *ngFor="let item of projectList; let projectIndex = index">
                      <span><b>{{ getTotalProduct(projectIndex) }}</b></span>
                    </td>
                    <td>
                      <span><b>{{ getTotalQualifyingCosts() | customCurrency: env.CurrencyFormat}}</b></span>
                    </td>
                  </tr>
                </tfoot>
                <ng-template #noRecords>
                  <tfoot>
                    <tr>
                      <td [colSpan]="3+projectList.length" class="text-center">{{commonLabelConstants.NoReacordFound}}
                      </td>
                    </tr>
                  </tfoot>
                </ng-template>
              </table>
            </div>
          </div>
      </div>
    </app-loader>
  </div>
</form>
